import React from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore'; // If using Firestore
import { auth, db } from '../firebase/firebaseConfig';

const ManagerRoute = ({ children }) => {
    const navigate = useNavigate();

    React.useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (!user) {
                navigate('/shop-login', { replace: true });
            } else {
                try {
                    // Adjust the collection name as per your DB structure
                    const userRef = doc(db, 'users', user.uid);
                    const userSnap = await getDoc(userRef);

                    if (userSnap.exists()) {
                        const userData = userSnap.data();

                        if (userData.type === 'Manager') {
                            // User is a Manager – allow access
                            // No action needed, just render children
                        } else {
                            // User logged in but not a Manager
                            navigate('/shop/dashboard', { replace: true });
                        }
                    } else {
                        // No user data found – fallback
                        navigate('/shop-login', { replace: true });
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                    navigate('/shop-login', { replace: true });
                }
            }
        });

        return () => unsubscribe();
    }, [navigate]);

    return children;
};

export default ManagerRoute;
